import { useState } from 'react';
import { useShallow } from 'zustand/shallow';

import { AutoFormButton } from 'app/modules/wallforming/components/auto-form/AutoFormButton';
import { InputBindingPanel } from 'app/modules/wallforming/components/input-binding/InputBindingPanel';
import { ArticleTools } from 'app/modules/wallforming/components/scenes/toolbar/content/ArticleTools';
import { CameraSettings } from 'app/modules/wallforming/components/scenes/toolbar/content/CameraSettings';
import { InteractionModeToggle } from 'app/modules/wallforming/components/scenes/toolbar/content/InteractionModeToggle';
import { PoiFilterButton } from 'app/modules/wallforming/components/scenes/toolbar/content/PoiFilterButton';
import { StoreyFilterButton } from 'app/modules/wallforming/components/scenes/toolbar/content/StoreyFilterButton';
import { ViewModeToggle } from 'app/modules/wallforming/components/scenes/toolbar/content/ViewModeToggle';
import { InteractionMode } from 'app/modules/wallforming/components/scenes/types/interactionMode';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { IS_DEV_ENV } from 'shared/constants';

export const Toolbar = () => {
    const [menuOpened, setMenuOpened] = useState<boolean>(false);
    const { interactionMode, isViewMode } = usePlacementStore(
        useShallow((state) => ({ interactionMode: state.interactionMode, isViewMode: state.isViewMode }))
    );

    return (
        <>
            <div className="absolute top-10 left-4 z-12000 rounded-md bg-background-default p-3">
                <div className="flex flex-col items-start justify-start gap-y-2">
                    <InputBindingPanel />
                    {IS_DEV_ENV && <CameraSettings menuOpened={menuOpened} setMenuOpened={setMenuOpened} />}
                    <ViewModeToggle />
                    <InteractionModeToggle />
                    <StoreyFilterButton />
                    {!isViewMode && <AutoFormButton menuOpened={menuOpened} />}

                    {/* POI navigation tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{ display: interactionMode === InteractionMode.POI_NAVIGATION ? 'flex' : 'none' }}
                    >
                        <PoiFilterButton menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
                    </div>

                    {/* Forming tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{
                            display: interactionMode === InteractionMode.DEFAULT && !isViewMode ? 'flex' : 'none'
                        }}
                    >
                        <ArticleTools menuOpened={menuOpened} />
                    </div>
                </div>
            </div>
        </>
    );
};
